var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.addParagraphs(_vm.truncatedBio))}}),_vm._v(" "),(_vm.displayShowMoreButton)?_c('a',{staticClass:"teal link hover-teal",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleShowMore.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baae4658","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/vue/js/modules/pro/profile/components/ProProfileBio.vue
// module id = null
// module chunks = 